export default {
    data: {},
    isLoaded: false,
    isInfoLoaded: false,
};
